export const servicesData = {
  "investment-advisory": {
    title: "Investment Advisory",
    subtitle: "Expert guidance to help you invest with clarity and confidence.",
    intro:
      "Our Investment Advisory service is designed to help individuals make informed financial decisions based on their goals, risk appetite, and future plans. We simplify investment choices and provide strategic recommendations that support long-term growth.",
    benefits: [
      "Personalized investment recommendations",
      "Risk-profile-based planning",
      "Professional market guidance",
      "Long-term wealth building approach",
    ],
    features: [
      {
        title: "Goal-Based Strategy",
        desc: "We align your investments with your financial goals, whether it is wealth creation, retirement planning, or capital preservation.",
      },
      {
        title: "Risk Assessment",
        desc: "Our advisory process considers your comfort level with risk and helps create a balanced investment path.",
      },
      {
        title: "Portfolio Review",
        desc: "We regularly review your investment strategy and suggest improvements based on performance and changing needs.",
      },
    ],
    cta: "Start building your investment future with expert advice tailored to your goals.",
  },

  "financial-planning": {
    title: "Financial Planning",
    subtitle: "Smart planning for a stable, secure, and successful future.",
    intro:
      "Financial Planning helps you organize your income, savings, expenses, insurance, and investments in a meaningful way. Our aim is to create a practical roadmap that supports your present needs and future ambitions.",
    benefits: [
      "Structured financial roadmap",
      "Retirement readiness support",
      "Savings and expense optimization",
      "Future-focused decision making",
    ],
    features: [
      {
        title: "Life Goal Planning",
        desc: "We help you prepare for major milestones like buying a home, funding education, or planning retirement.",
      },
      {
        title: "Cash Flow Management",
        desc: "Understand where your money goes and make your financial habits more efficient and productive.",
      },
      {
        title: "Long-Term Security",
        desc: "Our financial planning process strengthens your ability to face uncertainty with confidence.",
      },
    ],
    cta: "Take control of your money with a clear financial plan that supports every stage of life.",
  },

  "wealth-management": {
    title: "Wealth Management",
    subtitle: "Preserve, manage, and grow your assets with confidence.",
    intro:
      "Our Wealth Management service supports individuals who want a more structured approach to managing assets, protecting capital, and growing wealth over time. We bring together planning, allocation, and guidance into one coordinated strategy.",
    benefits: [
      "Holistic asset management",
      "Capital preservation support",
      "Long-term wealth growth",
      "Customized financial strategies",
    ],
    features: [
      {
        title: "Asset Allocation",
        desc: "We create a smart distribution strategy to balance growth potential and financial stability.",
      },
      {
        title: "Wealth Protection",
        desc: "Preserving wealth is as important as growing it, and our approach reflects both priorities.",
      },
      {
        title: "Strategic Monitoring",
        desc: "We review and refine your wealth strategy regularly to keep it aligned with your goals.",
      },
    ],
    cta: "Create a stronger financial future with a wealth strategy built around your ambitions.",
  },

  "portfolio-strategy": {
    title: "Portfolio Strategy",
    subtitle: "Thoughtful portfolio planning for smarter risk and stronger returns.",
    intro:
      "Portfolio Strategy focuses on creating an investment mix that fits your financial profile, goals, and timeline. We help you avoid random decisions and build a disciplined portfolio designed for consistency and resilience.",
    benefits: [
      "Better diversification",
      "Risk-adjusted planning",
      "Clear investment structure",
      "Disciplined long-term strategy",
    ],
    features: [
      {
        title: "Portfolio Design",
        desc: "We design portfolios with balance, diversification, and long-term relevance in mind.",
      },
      {
        title: "Performance Alignment",
        desc: "Every portfolio recommendation is aligned with your personal financial objectives.",
      },
      {
        title: "Strategic Rebalancing",
        desc: "As markets and goals change, we help rebalance your portfolio to stay on track.",
      },
    ],
    cta: "Build a portfolio that works with your goals, not against them.",
  },

  "sub-broking": {
    title: "Sub Broking",
    subtitle: "Grow with us as a trusted financial distribution partner.",
    intro:
      "Our Sub Broking service is ideal for individuals and professionals who want to expand into the financial services space with expert backing and operational support. We help you build credibility, client relationships, and business growth.",
    benefits: [
      "Business growth opportunity",
      "Supportive partnership model",
      "Client-oriented financial solutions",
      "Reliable back-end assistance",
    ],
    features: [
      {
        title: "Partner Support",
        desc: "We provide guidance and operational support to help you serve clients more effectively.",
      },
      {
        title: "Market Opportunity",
        desc: "Step into the growing financial services sector with a trusted professional network.",
      },
      {
        title: "Scalable Growth",
        desc: "Our sub broking model supports long-term growth and relationship-driven success.",
      },
    ],
    cta: "Start your journey as a financial partner with the right support and opportunity.",
  },

  "mutual-funds": {
    title: "Mutual Funds",
    subtitle: "Carefully selected fund solutions for every kind of investor.",
    intro:
      "Our Mutual Funds service helps investors choose fund options that suit their financial goals, investment horizon, and comfort with risk. We guide you through fund selection with simplicity, clarity, and strategy.",
    benefits: [
      "Wide range of fund options",
      "Goal-focused recommendations",
      "Professional selection support",
      "Easy diversification",
    ],
    features: [
      {
        title: "Fund Selection",
        desc: "We help you choose mutual funds based on goals such as growth, income, tax planning, or stability.",
      },
      {
        title: "Investor Suitability",
        desc: "Recommendations are matched with your timeline, comfort level, and financial priorities.",
      },
      {
        title: "Ongoing Guidance",
        desc: "We support you in reviewing and refining your mutual fund choices over time.",
      },
    ],
    cta: "Invest smarter with mutual fund options chosen around your financial journey.",
  },
};